export default {
  "en": {
    "form": {
      "actions": {
        "cancel": "Cancel",
        "saveChanges": "Save changes"
      },
      "back": "Previous step",
      "password": "Password",
      "steps": "Step {count} of {total}",
      "writeEmployeeNameReject": "Write <i><b>{employeeName}</b></i> to continue."
    }
  }
}